import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=4cc5446f&scoped=true&"
import script from "./materials.vue?vue&type=script&lang=js&"
export * from "./materials.vue?vue&type=script&lang=js&"
import style0 from "./materials.vue?vue&type=style&index=0&lang=css&"
import style1 from "./materials.vue?vue&type=style&index=1&id=4cc5446f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5446f",
  null
  
)

export default component.exports